import { useState } from "react";
import { api, apiError } from "../lib/api";
import { orderItems } from "../lib/constants";
import { openSevkFormu } from "../lib/sevkForm";
import { toast } from "sonner";
import { X, PackageCheck, FileText } from "lucide-react";

export function DeliverModal({ order, dark = false, onClose, onDone }) {
  const [received, setReceived] = useState(order.received_by || "");
  const [makeForm, setMakeForm] = useState(true);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/orders/${order.id}/deliver`, { received_by: received });
      toast.success(`#${order.order_no} teslim edildi olarak kaydedildi`);
      if (makeForm) openSevkFormu(data || { ...order, received_by: received });
      onDone && onDone();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const panel = dark
    ? "border-cyan-500/40 bg-[#111827] text-white"
    : "border-cyan-500/40 bg-white text-foreground";
  const input = dark
    ? "border-slate-700 bg-slate-800 text-white"
    : "border-border bg-white";
  const cancelCls = dark
    ? "border-slate-600 bg-slate-800 text-slate-200 hover:bg-slate-700"
    : "border-border bg-white hover:bg-secondary";

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm" data-testid="deliver-modal">
      <div className={`w-full max-w-md rounded-2xl border p-5 shadow-2xl ${panel}`}>
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-500/15 text-cyan-500">
              <PackageCheck className="h-6 w-6" />
            </div>
            <div>
              <h3 className="font-display text-lg font-bold">Teslim Et</h3>
              <p className={`text-sm ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
                #{order.order_no} · {order.customer_snapshot?.company_name}
              </p>
            </div>
          </div>
          <button onClick={onClose} className={dark ? "text-slate-400" : "text-muted-foreground"}><X className="h-5 w-5" /></button>
        </div>

        <div className={`mb-4 rounded-xl p-3 text-sm ${dark ? "bg-slate-800/60 text-slate-300" : "bg-secondary/50 text-muted-foreground"}`}>
          {orderItems(order).map((it, i) => (
            <div key={i}>{it.product_code} {it.product_name} · {it.quantity} {it.unit}</div>
          ))}
        </div>

        <label className={`mb-1.5 block text-sm font-semibold ${dark ? "text-slate-300" : "text-foreground"}`}>Teslim Alan Kişi</label>
        <input
          data-testid="deliver-received-by"
          value={received}
          onChange={(e) => setReceived(e.target.value)}
          placeholder="Ad Soyad (opsiyonel)"
          className={`mb-4 w-full rounded-xl border px-4 py-3 outline-none focus:border-cyan-500 ${input}`}
        />

        <label data-testid="deliver-make-form" onClick={() => setMakeForm((v) => !v)} className={`mb-4 flex cursor-pointer items-center gap-2.5 rounded-xl border px-3.5 py-3 ${dark ? "border-slate-700 bg-slate-800/60" : "border-border bg-secondary/40"}`}>
          <span className={`flex h-5 w-5 items-center justify-center rounded-md border ${makeForm ? "border-cyan-500 bg-cyan-500 text-white" : dark ? "border-slate-500" : "border-muted-foreground/40 bg-white"}`}>
            {makeForm && <PackageCheck className="h-3.5 w-3.5" />}
          </span>
          <FileText className="h-4 w-4 text-cyan-500" />
          <span className="text-sm font-semibold">Teslimle birlikte sevk formu oluştur (yazdır)</span>
        </label>

        <div className="flex gap-3">
          <button data-testid="deliver-cancel-btn" onClick={onClose} disabled={busy} className={`flex items-center justify-center gap-2 rounded-xl border px-4 py-3 font-semibold ${cancelCls}`}>
            <X className="h-4 w-4" /> Vazgeç
          </button>
          <button data-testid="deliver-confirm-btn" onClick={submit} disabled={busy} className="flex-1 rounded-xl bg-cyan-500 py-3 font-bold text-white hover:bg-cyan-400 disabled:opacity-50">
            {busy ? "Kaydediliyor..." : "Teslim Edildi Olarak Kaydet"}
          </button>
        </div>
      </div>
    </div>
  );
}
